import * as React from 'react'

export type Props = {
  option: any,
}

export const HybridSettingsPageResourceType = (props: Props) => {
  switch (props.option.type) {
    case 'SERVER':
      return (<span className={'opt-type'}>Server</span>)
    case 'SERVER_GROUP':
      return (<span className={'opt-type'}>Group</span>)
    default:
      return (<span className={'opt-type'}>Cluster</span>)
  }
}
